// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"ea7ae9dd","453":"d597de1b","732":"a5c8d181","977":"c6a8e43a"}[chunkId] + ".chunk.js";
};